import "./NewNoteBar.css";
import EnterNewNote from "./EnterNewNote/EnterNewNote";
import { useEffect, useState, useRef} from "react";


function NewNoteBar({bgColor, darkBG}){
    const [isNewNoteOpen, setIsNewNoteOpen] = useState(false);
    const newNoteRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
        if (newNoteRef.current && !newNoteRef.current.contains(event.target)) {
            setIsNewNoteOpen(false);
        }
        };
            document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleNewNoteClick = () => {
        setIsNewNoteOpen(!isNewNoteOpen);
    };

    return(
        <div className="new-note-bar my-5"> 
                <i class="fa-solid fa-star star-icon-left"></i>
                <i class="fa-solid fa-star star-icon-right"></i>
            <div style={{backgroundColor: darkBG}} className="new-note-bar-container text-center py-3">
                <input onClick={handleNewNoteClick} style={{backgroundColor: bgColor}} className="new-note-input py-2" type="search" placeholder="Enter a Note" aria-label="Search"/>
            </div>

            {isNewNoteOpen && (
                <EnterNewNote newNoteRef={newNoteRef} darkBG={darkBG}/>
            )}
        </div>
    )
}

export default NewNoteBar;